import React from 'react'

import { Badge } from '@toasttab/shared/src/components'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const Metrics = ({ body }: { body: any }) => {
  return (
    <section className='mb-10 lg:mb-16' {...(body.id && { id: body.id })}>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 mb-6 mb-0 lg:mr-6'>
            <img
              className='mx-auto max-w-[200px] lg:max-w-[358px]'
              src={body.columns.left?.assets?.image?.src}
              alt={body.columns.left?.assets?.image?.title}
            />
          </div>
          <div className='col-span-4 lg:col-span-8'>
            <div className='items-center lg:items-start mb-10 text-center lg:text-left lg:max-w-[746px]'>
              {Boolean(body.columns.right?.badge?.text) && (
                <Badge
                  badgeColor='bg-grass-0'
                  classes='!font-normal mb-4 text-success text-[1.375rem]'
                  icon='metricUpTrend'
                  text={body.columns.right?.badge?.text}
                />
              )}
              {Boolean(body.columns.right?.quote) && (
                <Typography
                  as='h2'
                  variation='h2'
                  classes='font-effra font-normal tex-[1.938rem] lg:text-[3.313rem] text-primary leading-[2.5rem] lg:leading-[4rem] mb-10'
                  allowHtml={false}
                >
                  "{body.columns.right?.quote}
                  {body.columns.right?.subscriptSymbol && (
                    <span className='text-sm align-top'>
                      {body.columns.right?.subscriptSymbol}
                    </span>
                  )}
                  "
                </Typography>
              )}
              {Boolean(body.columns.right?.assets?.image?.src) && (
                <img
                  className='block mx-auto lg:mx-0'
                  src={body.columns.right?.assets?.image?.src}
                  alt=''
                />
              )}
              {Boolean(body.columns.right?.author) && (
                <Typography
                  as='h5'
                  variation='default'
                  classes='!font-effra !font-semibold !text-[22px] text-secondary !leading-[1.688rem] lg:mb-8'
                  allowHtml={false}
                >
                  {body.columns.right?.author}
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Metrics
